import type { ReactElement } from 'react';
import { SitePageShell } from '@/shared/ui';
import { QuoteDesignPicker } from '@/widgets/quote-design-picker';
import { QuoteGuideContact } from '@/widgets/quote-guide-contact';
import { QuoteGuideFaq } from '@/widgets/quote-guide-faq';
import { QuoteGuideHero } from '@/widgets/quote-guide-hero';
import { QuoteGuideShortcuts } from '@/widgets/quote-guide-shortcuts';
import { QuoteGuideSteps } from '@/widgets/quote-guide-steps';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** "내 디자인으로 견적 요청" 섹션의 id — 첫 화면 버튼이 같은 화면 안에서 그리로 내려간다. */
const DESIGNS_SECTION_ID = 'quote-designs';

/**
 * 견적문의(/request) — 안내와 바로가기 화면. 진행 과정·저장한 디자인으로 요청·바로가기·고객센터·자주 묻는 질문을
 * 차례로 쌓는다. 디자인 요청 폼은 디자인별 화면(/request/:designId)이고, 편집영역 없는 상품은 상세에서 바로 요청한다
 * (2026-10-30 일반 견적 설계, /request/product/:productId).
 */
export const QuoteGuidePage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
    <div className="flex flex-col gap-24 sm:gap-32">
      <QuoteGuideHero designsSectionId={DESIGNS_SECTION_ID} />
      <QuoteGuideSteps />
      <QuoteDesignPicker id={DESIGNS_SECTION_ID} />
      <QuoteGuideShortcuts />
      <QuoteGuideContact />
      <QuoteGuideFaq />
    </div>
  </SitePageShell>
);
